export const NUMBER_OF_ALMOST_EXPIRED_DATE = 7
export const FOR_CONASI_TARGET = process.env.VUE_APP_FOR_CONASI.trim() == "true" ? true : false